import React from 'react';
import { Toolbar, SaveButton, ReferenceInput, DeleteButton, Link, Button, Edit, Create, SimpleForm, SelectInput } from 'react-admin';
import { parse } from "query-string";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const EditTourVanPassengerTitle = () => (
  <span>
    Edit Tour Van Passenger
  </span>
);

const TourVanPassengerEditToolbar = props => (
  <Toolbar {...props} >
      <SaveButton />
      <CancelButton object={props.record} />
      <DeleteButton basePath={props.basePath} record={props.record} resource={props.resource} redirect={`/tours/${props.record.tour_id}/3`} /> 
  </Toolbar>
);

const TourVanPassengerCreateToolbar = props => (
  <Toolbar {...props} >
      <SaveButton />
      <CancelButton object={props.record} />
  </Toolbar>
);

const CreateTourVanPassengerTitle = () => (
  <span>
    Create Tour Van Passenger
  </span>
);

const CancelButton = (record) => (
  <Button
      component={Link}
      to={{
          pathname: `/tours/${record.object.tour_id}/3`
      }}
      label="Cancel">
      <ArrowBackIcon />
  </Button>
);

export const TourVanPassengerEdit = props => {
  const tour_id =  parse(props.location.search).tour_id
  const redirect = tour_id ? `/tours/${tour_id}/3` : 'edit';

  return (
  <Edit title={<EditTourVanPassengerTitle />} {...props}>
    <SimpleForm redirect={redirect} toolbar={<TourVanPassengerEditToolbar />}>
      <ReferenceInput label="Passenger" source="client_id" reference="tour_passengers"  filter={{ tour_id: tour_id }}>
        <SelectInput source="id" optionText="full_name"/>
      </ReferenceInput>
    </SimpleForm>
  </Edit>
  );
}

export const TourVanPassengerCreate = props => {
  const tour_id =  parse(props.location.search).tour_id
  const redirect = tour_id ? `/tours/${tour_id}/3` : 'edit';

  return (
  <Create title={<CreateTourVanPassengerTitle />} {...props}>
  <SimpleForm toolbar={<TourVanPassengerCreateToolbar/>} redirect={redirect}>
      <ReferenceInput label="Passenger" source="client_id" reference="tour_passengers"  filter={{ tour_id: tour_id }}>
        <SelectInput source="id" optionText="full_name"/>
      </ReferenceInput>
    </SimpleForm>
  </Create>
  );
}


// WEBPACK FOOTER //
// ./src/resources/tourVanPassengers.js